import { get, post, put } from '../utils/makeRequest';

const USER_ENDPOINTS = {
  LOGIN: '/auth/login',
  REGISTER: '/auth/register',
  UPDATE_PROFILE: '/company/update-profile',
  VERIFY_EMAIL: '/auth/verify-email',
  REQUEST_PASSWORD_RESET: '/auth/request-password-reset',
  VERIFY_RESET_CODE: '/auth/verify-reset-code',
  RESET_PASSWORD: '/auth/reset-password',
  CHANGE_PASSWORD: '/auth/change-password',
  RESEND_VERIFICATION: '/auth/resend-verification', // Add this
  GET_PROFILE: '/company/get-profile',
  CREATE_TICKET: '/company/create-ticket',
  GET_TICKETS: '/company/get-tickets',
};

export const userService = {
  /**
   * Login user
   * @param {object} credentials - User credentials
   * @returns {Promise} - User data and token
   */
  login: async (credentials) => {
    return post(USER_ENDPOINTS.LOGIN, credentials);
  },

  /**
   * Register new user
   * @param {object} userData - User registration data
   * @returns {Promise} - Created user data
   */
  register: async (userData) => {
    return post(USER_ENDPOINTS.REGISTER, userData);
  },

  /**
   * Verify user email
   * @param {string} token - Email verification token
   * @returns {Promise} - Verification result
   */
  verifyEmail: async (token) => {
    return get(`${USER_ENDPOINTS.VERIFY_EMAIL}/${token}`);
  },

  /**
   * Request password reset
   * @param {string} email - User's email address
   * @returns {Promise} - Request result
   */
  requestPasswordReset: async (email) => {
    return post(USER_ENDPOINTS.REQUEST_PASSWORD_RESET, { email });
  },

  /**
   * Verify reset code
   * @param {object} data - Email and verification code
   * @returns {Promise} - Verification result
   */
  verifyResetCode: async (data) => {
    return post(USER_ENDPOINTS.VERIFY_RESET_CODE, data);
  },

  /**
   * Reset password
   * @param {object} data - User ID and new password
   * @returns {Promise} - Reset result
   */
  resetPassword: async (data) => {
    return post(USER_ENDPOINTS.RESET_PASSWORD, data);
  },

  /**
   * Get user profile
   * @returns {Promise} - User profile data
   */
  getProfile: async () => {
    return get(USER_ENDPOINTS.GET_PROFILE);
  },

  /**
   * Update user profile
   * @param {object} profileData - Updated profile data
   * @returns {Promise} - Updated user profile
   */
  updateProfile: async (profileData) => {
    return put(USER_ENDPOINTS.UPDATE_PROFILE, profileData);
  },

  /**
   * Create a support ticket
   * @param {string} request_message - The user's support request message
   * @returns {Promise} - Ticket creation result
   */
  createTicket: async (request_message) => {
    return post(USER_ENDPOINTS.CREATE_TICKET, { request_message });
  },

  /**
   * Get all support tickets
   * @returns {Promise} - List of support tickets
   */
  getTickets: async () => {
    return get(USER_ENDPOINTS.GET_TICKETS);
  },

  /**
   * Get dashboard info
   * @returns {Promise} - Dashboard info data
   */
  getDashboardInfo: async () => {
    return get('/company/dashboard-info');
  },

  /**
   * Change user password
   * @param {string} newPassword - New password
   * @param {string} confirmPassword - Confirm password
   * @returns {Promise} - Password change result
   */
  changePassword: async (newPassword, confirmPassword) => {
    return post(USER_ENDPOINTS.CHANGE_PASSWORD, {
      new_password: newPassword,
      confirm_password: confirmPassword
    });
  },

  /**
   * Resend verification email
   * @param {string} email - User's email address
   * @returns {Promise} - Resend result
   */
  resendVerificationEmail: async (email) => {
    return post(USER_ENDPOINTS.RESEND_VERIFICATION, { email });
  },
}; 